import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getCabanaCategoriesList(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-cabana-categories?page=" + actions.page
        : apiUrl + "/opa-cabana-categories" + actions.query;
    //     ? apiUrl + "/opa-cabana-categories?page=" + actions.page + "&include=images"
    //    : apiUrl + "/opa-cabana-categories" + actions.query + "&include=images";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);


    yield put({ type: "LIST_CABANA_CATEGORIES_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_CABANA_CATEGORIES_RESPONSE_GET", value: error });
  }
}


function* getSagaCabanasCategory(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-cabana-category/"
        : `${apiUrl}/opa-cabana-category/${actions.query}?include=images,products,inclusions,exclusions,accessibility`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response) {
        responseStatus = "success";
      } else {
        responseStatus = response;
      }
    }

    yield put({ type: "CABANAS_CATEGORY_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "CABANAS_CATEGORY_RESPONSE_GET", value: error });
  }
}


function* addCabanaCategory(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.data),
    };

    let url = apiUrl + "/opa-cabana-category";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CABANA_CATEGORY_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "CABANA_CATEGORY_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* editSagaCabanasCategory(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const formData = { ...actions.form };

    if (formData.uuid) {
      delete formData.uuid;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };
    let url = `${apiUrl}/opa-cabana-category/${actions.id}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }
    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.name) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CABANAS_CATEGORY_RESPONSE_EDIT",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "CABANAS_CATEGORY_RESPONSE_EDIT",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* deleteCabanaCategory(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };


    let url = apiUrl + "/opa-cabana-category/" + actions.cabanaCategoryUuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "delete", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CABANA_CATEGORY_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "CABANA_CATEGORY_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}




function* addSAGAInclusionsExclusionsAccessibility(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    // access, data, id}),

    const formData = { ...actions.data };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(formData),
    };
    let url = `${apiUrl}/opa-cabana-category/${actions.id}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }
    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.name) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "CABANAS_CATEGORY_RESPONSE_EDIT",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "CABANAS_CATEGORY_RESPONSE_EDIT",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}


function* getCabanasUnmappedCount(actions) {
  let uuid = getSetCookie();

  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-products-cabana/without-mappings/count"
        : apiUrl + "/opa-products-cabana/without-mappings/count";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({
      type: "LIST_CABANAS_UNMAPPED_COUNT_RESPONSE_GET",
      value: response,
    });
  } catch (error) {
    yield put({ type: "LIST_CABANAS_UNMAPPED_COUNT_RESPONSE_GET", value: error });
  }
}

function* resetCabanaCategory() {
  yield put({ type: "CABANA_CATEGORY_RESET" });
}

function* resetCabanaCategoryList() {
  yield put({ type: "CABANA_CATEGORY_RESET_LIST" });
}

export function* getSagaCabanaCategoriesList() {
  yield takeEvery("GET_LIST_CABANA_CATEGORIES", getCabanaCategoriesList);
}

export function* addSagaCabanaCategory() {
  yield takeEvery("ADD_CABANA_CATEGORY", addCabanaCategory);
}

export function* resetCabanaCategoryAdd() {
  yield takeEvery("RESET_ADD_CABANA_CATEGORY_STATE", resetCabanaCategory);
}

export function* resetListCabanaCategoryList() {
  yield takeEvery("RESET_LIST_CABANA_CATEGORY_STATE", resetCabanaCategoryList);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};

export function* getCabanasCategory() {
  yield takeEvery("GET_CABANAS_CATEGORY", getSagaCabanasCategory);
}

export function* editCabanasCategory() {
  yield takeEvery("EDIT_CABANAS_CATEGORY", editSagaCabanasCategory);
}

export function* deleteSagaCabanaCategory() {
  yield takeEvery("DELETE_CABANA_CATEGORY", deleteCabanaCategory);
}

export function* addInclusionsExclusionsAccessibility() {
  yield takeEvery("ADD_INCLUSIONS_EXCLUSIONS_ACCESSIBILITY", addSAGAInclusionsExclusionsAccessibility);
}


export function* getSagaCabanasUnmappedCount() {
  yield takeEvery("GET_CABANAS_UNMAPPED_COUNT", getCabanasUnmappedCount);
}





